'use client'

import { Typo3SectionSpotHeadlessHtml } from '@/types'
import { Container, Section } from '@/ui/components'
import { memo, useEffect, useRef } from 'react'

interface Props {
  data: Typo3SectionSpotHeadlessHtml
}

const SpotHeadlessHtml = ({ data }: Props) => {
  const c = data.content
  const contentRef = useRef(null)

  useEffect(() => {
    // Funktion zum Hinzufügen eines Skripts
    const addScript = (src: string) => {
      const script = document.createElement('script')

      if (src.trim().startsWith('<script')) {
        const tempDiv = document.createElement('div')
        tempDiv.innerHTML = src.trim()
        const parsedScript = tempDiv.querySelector('script')

        if (parsedScript) {
          if (parsedScript.src) {
            script.src = parsedScript.src.startsWith('//')
              ? `${window.location.protocol}${parsedScript.src}`
              : parsedScript.src
          }
          Array.from(parsedScript.attributes).forEach((attr) => {
            if (attr.name !== 'src' && attr.name !== 'type') {
              script.setAttribute(attr.name, attr.value)
            }
          })
        }
      } else {
        script.src = src
      }

      script.async = true
      document.body.appendChild(script)
    }

    // Inline-JavaScript hinzufügen
    if (c?.javascript) {
      const inlineScript = document.createElement('script')
      inlineScript.innerHTML = c.javascript
      document?.body?.appendChild(inlineScript)
    }

    // Externes JavaScript hinzufügen, falls vorhanden
    if (Array.isArray(c?.filesJavascript)) {
      c.filesJavascript.forEach((file) => {
        addScript(file)
      })
    }

    // Aufräumen der dynamisch hinzugefügten Skripte
    return () => {
      // Entfernen des Inline-Skripts
      if (c?.javascript) {
        const scripts = Array.from(document.getElementsByTagName('script'))
        scripts.forEach((script) => {
          if (script.innerHTML === c.javascript) {
            document.body.removeChild(script)
          }
        })
      }

      // Entfernen der externen Skripts
      if (Array.isArray(c?.filesJavascript)) {
        const externalScripts = Array.from(
          document.getElementsByTagName('script')
        )
        externalScripts.forEach((script) => {
          if (c?.filesJavascript && c?.filesJavascript.includes(script.src)) {
            document.body.removeChild(script)
          }
        })
      }
    }
  }, [c?.javascript, c?.filesJavascript])

  return (
    <Section data={data} className="s-spotheadless-html">
      <Container>
        {/* Inject custom styles */}
        <style jsx>{`
          .html-content {
            ${c?.style}
          }
        `}</style>

        {/* Inject HTML dynamically */}
        {c?.html && (
          <div
            ref={contentRef}
            className="html-content"
            dangerouslySetInnerHTML={{ __html: c.html }}
          />
        )}
      </Container>
    </Section>
  )
}

export default memo(SpotHeadlessHtml)
